/**
 * Componente PageHeader - ConfereAI
 *
 * Cabeçalho padrão para todas as páginas do sistema.
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonIcon?: string;
  children?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  buttonText,
  onButtonClick,
  buttonIcon = 'fas fa-plus',
  children,
}) => {
  return (
    <div className="page-header">
      <h1>{title}</h1>
      {children ? (
        children
      ) : buttonText && onButtonClick ? (
        <button className="btn btn-primary" onClick={onButtonClick}>
          <i className={buttonIcon}></i>
          {buttonText}
        </button>
      ) : null}
    </div>
  );
};

export default PageHeader;
